
import React from "react";
import "./Toggle.css"
const ToggleChoice= ({state,toggleState,name,type}) =>{
    
return(
       <div  className="popup-input-card">
       
        <label   class="switchmutesmall ">
 <input id="togglemutesmall" checked={state} onChange={e=>{toggleState(e.target.checked)}} name={name} type={type}  
    /> 
  <span class="sliderlfmutesmall round"></span>
</label>
    
    </div>
    
)

}

export default ToggleChoice;

